import React, { useEffect, useState } from "react";
import { Button, Container, Tab, Table } from "semantic-ui-react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { format } from "date-fns";
import { ApplicationState } from "../../../store";
import { AuthenticationState } from "../../../model/state/authentication-state";
import { PaginatedTable } from "../../generic/paginated-table/paginated-table";
import { StatutProjet } from "../../../model/entities/statut-projet";
import { SubmitButton } from "../../generic/submit-button";
import { TableauAmortissementResponse } from "../../../model/dto/response";
import { investmentService } from "../../../services/investment-service";
import { InvestissementsPane } from "./tab/investissements-pane";
import { EcheancesPane } from "./tab/echeances-pane";

type HistoInvestissement = {
  Id: number,
  Titre: string;
  TauxInteretCitoyen: number;
  MontantInvesti: number;
  MontantPercu: number;
  EndDate: string;
  Statut: string;
};

type Props = {
  loginProps?: AuthenticationState;
};

const panes = [
  {
    menuItem: 'Mes projets',
    render: () => {
        return (
            <Tab.Pane attached={false} css={{
                background: 'transparent !important',
                border: 'none !important'
            }}>
              <InvestissementsPane />
            </Tab.Pane>
        )
    },
  },
  {
    menuItem: 'Mes échéances',
    render: () => {
        return (
            <Tab.Pane attached={false} css={{
                background: 'transparent !important',
                border: 'none !important'
            }}>
              <EcheancesPane />
            </Tab.Pane>
        )
    },
  },
]

const Tabs = () => (
  <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
)

function DashboardCollectivite({ loginProps }: Props) {
  return (
    <Container>
      <Tabs />
    </Container>
  );
}

const mapStateToProps = (state: ApplicationState) => ({
  loginProps: state.authentication,
});

const ConnectedDashboardCollectivite = connect(
  mapStateToProps,
  null
)(DashboardCollectivite);
export { ConnectedDashboardCollectivite as DashboardCollectivite };
